import { Box, Grid, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import boxStyles from "../../styles/boxStyles";

const CreatePermissions = ({
  inputFields,
  setInputFields,
  readOnly = false,
  action,
}) => {
  return (
    <>
      <Box component="div" sx={boxStyles}>
        <Grid container spacing={3}>
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="kodeKbo"
                label="Kode KBO"
                variant="standard"
                fullWidth
                value={inputFields.kodeKbo ? inputFields.kodeKbo : ""}
                InputLabelProps={{ shrink: inputFields.kodeKbo !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    kodeKbo: e.target.value,
                  })
                }
                disabled={readOnly || action == "read"}
              />
              <TextField
                name="namaRegion"
                label="Nama Region"
                variant="standard"
                fullWidth
                value={inputFields.namaRegion ? inputFields.namaRegion : ""}
                InputLabelProps={{ shrink: inputFields.namaRegion !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    namaRegion: e.target.value,
                  })
                }
                disabled={readOnly || action == "read"}
              />
              <TextField
                name="managerHsseEmail"
                label="Manager HSSE Email"
                variant="standard"
                fullWidth
                value={
                  inputFields.managerHsseEmail
                    ? inputFields.managerHsseEmail
                    : ""
                }
                InputLabelProps={{
                  shrink: inputFields.managerHsseEmail !== "",
                }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    managerHsseEmail: e.target.value,
                  })
                }
                disabled={readOnly || action == "read"}
              />
              <TextField
                name="managerHsseDisplayName"
                label="Manager HSSE Display Name"
                variant="standard"
                fullWidth
                value={
                  inputFields.managerHsseDisplayName
                    ? inputFields.managerHsseDisplayName
                    : ""
                }
                InputLabelProps={{
                  shrink: inputFields.managerHsseDisplayName !== "",
                }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    managerHsseDisplayName: e.target.value,
                  })
                }
                disabled={readOnly || action == "read"}
              />
              <TextField
                name="jabatanUser"
                label="Jabatan User"
                variant="standard"
                fullWidth
                value={inputFields.jabatanUser ? inputFields.jabatanUser : ""}
                InputLabelProps={{ shrink: inputFields.jabatanUser !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    jabatanUser: e.target.value,
                  })
                }
                disabled={readOnly || action == "read"}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CreatePermissions;
